import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "cardNumberFormat" })
export class CardNumberFormatPipe implements PipeTransform {
  transform(value: any, ...args: any[]) {
    return value.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/g, "$1 $2 $3 $4");
  }
}
